module.exports = __webpack_public_path__ + "img/icon-edit.3a5b5239.svg";